module.exports = __webpack_public_path__ + "img/car1_6.a9ad7287.png";